import React, { AriaAttributes } from "react";
import { InputNumber, InputNumberProps } from "primereact/inputnumber";

type OrderPricingNumberInputProps = Pick<InputNumberProps,
  "disabled" | "mode" | "currency" | "locale" | "inputMode" | "min" |
  "minFractionDigits" | "maxFractionDigits" | "onBlur" | "onKeyDown" | "placeholder"
> & {
  ariaLabel: string;
  ariaDescribedBy?: string;
  ariaInvalid?: AriaAttributes["aria-invalid"];
  id?: string;
  value?: string | number | null;
  onChange?: (value: string) => void;
};

const inputClassName =
  "w-28 rounded-md border border-gray-300 px-2 py-1 text-right text-sm tabular-nums focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500 disabled:bg-gray-50";

function numericValue(value: OrderPricingNumberInputProps["value"]) {
  if (value === "" || value == null) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export default function OrderPricingNumberInput({
  ariaLabel,
  ariaDescribedBy,
  ariaInvalid,
  disabled = false,
  id,
  mode = "currency",
  currency = "USD",
  locale = "en-US",
  inputMode = "decimal",
  min = 0,
  minFractionDigits = 2,
  maxFractionDigits = 4,
  onBlur,
  onChange,
  onKeyDown,
  placeholder,
  value,
}: OrderPricingNumberInputProps) {
  const updateValue = (event: { value?: number | null }) => onChange?.(event.value == null ? "" : String(event.value));
  return (
    <InputNumber
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid}
      className="w-28"
      currency={currency}
      disabled={disabled}
      inputClassName={inputClassName}
      inputMode={inputMode}
      inputId={id}
      locale={locale}
      maxFractionDigits={maxFractionDigits}
      min={min}
      minFractionDigits={minFractionDigits}
      mode={mode}
      onBlur={onBlur}
      onChange={updateValue}
      onKeyDown={onKeyDown}
      onValueChange={updateValue}
      placeholder={placeholder}
      showButtons={false}
      value={numericValue(value)}
    />
  );
}
